import styles from './splits-info-popover.module.css'

import { RxCross2 } from '@react-icons/all-files/rx/RxCross2'
import { RxInfoCircled } from '@react-icons/all-files/rx/RxInfoCircled'
import * as React from 'react'
import { useNavigate } from 'react-router-dom'

import { sendMixpanelEvent } from '@disco/state-management/actions/AnalyticsActions'

import { Box, Code, Flex, IconButton, Link, Popover, Text } from 'components/ds'

import { useDispatch } from 'hooks/use-redux'

type Props = {
  title: string
  description: string
  example: string
}

/**
 * Info popover shown next to a field label when this business writes Rights
 * splits into that field's metadata on export — explains the format and
 * links to where that behavior is configured.
 */
const SplitsInfoPopover = ({
  title,
  description,
  example,
}: Props): React.ReactElement => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [open, setOpen] = React.useState(false)

  const handleBusinessSettingsClick = (event: React.MouseEvent) => {
    event.preventDefault()
    navigate('/settings/business')
    dispatch(sendMixpanelEvent('Change business settings (modal)'))
  }

  return (
    <Popover.Root open={open} onOpenChange={setOpen}>
      <Popover.Trigger>
        <IconButton
          type="button"
          variant="ghost"
          color="gray"
          size="1"
          className={styles.trigger}
          aria-label={`${title} info`}
        >
          <RxInfoCircled size={14} />
        </IconButton>
      </Popover.Trigger>
      <Popover.Content width="280px">
        <Flex justify="between" align="center" mb="2">
          <Text size="3" weight="bold">
            {title}
          </Text>
          <IconButton
            type="button"
            variant="ghost"
            color="gray"
            size="1"
            aria-label="Close"
            onClick={() => setOpen(false)}
          >
            <RxCross2 />
          </IconButton>
        </Flex>
        <Text as="p" size="2" color="gray" mb="3">
          {description}
        </Text>
        <Box className={styles.exampleBox} mb="3">
          <Code size="1" variant="ghost">
            {example}
          </Code>
        </Box>
        <Text as="p" size="2" color="gray">
          Change this in{' '}
          <Link href="/settings/business" onClick={handleBusinessSettingsClick}>
            business settings
          </Link>
          .
        </Text>
      </Popover.Content>
    </Popover.Root>
  )
}

export default SplitsInfoPopover
